import React from 'react';

export default function Empty({validator}) {
    validator.current = () => {
        return true;
    };

     return (
        <div>
        </div>
     );
};